import { render, staticRenderFns } from "./dGroupsBar.vue?vue&type=template&id=82129546&"
import script from "./dGroupsBar.vue?vue&type=script&lang=js&"
export * from "./dGroupsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports